export enum NotificationStatusEnum {
    Error = 0,
    Enqueued = 1,
    Sent = 2,
    Read = 3
}
